import { motion } from 'framer-motion';

export const Logo = ({ className = 'w-12 h-12' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className={`relative flex flex-col items-center justify-center ${className}`}
    >
      <svg
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
        aria-hidden="true"
      >
        {/* Stylized R and P Monogram */}
        <path
          d="M40 28V72M40 28H58C66 28 72 34 72 42C72 50 66 56 58 56H40M40 56L72 72"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Inner vertical bar creating the 'P' effect within the 'R' structure */}
        <path
          d="M55 40V72"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
        />
      </svg>
    </motion.div>
  );
};

export const LogoWithText = ({ className = '' }) => {
  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      <Logo className="w-16 h-16" />
      <span className="text-xl font-medium tracking-tight uppercase text-white">Rayhan Patel</span>
    </div>
  );
};

export default Logo;
